import { useEffect, useState } from 'react';

/*
 * timings: time in seconds to delay each state transition
 * strings: what each state should be for the text value
 */
export const useProgressiveLoading: Function = (
  timings: number[] = [5, 15, 30],
  strings: string[] = [
    'Still loading, please wait...',
    'Still loading, please wait a while longer...',
    'Still loading, thank you for your patience...',
  ]
) => {
  const [text, setText] = useState<string>('');

  useEffect(() => {
    const ids = timings.map((delay: number, index: number) =>
      setTimeout(() => setText(strings[index]), delay * 1000)
    );
    return () => ids.forEach(id => clearTimeout(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [text];
};
